enum Key {
  ENTER = 13,
  SPACE = 32,
}

export default Key;
